export default __webpack_public_path__ + "static/media/2.bbd36752.png";